const READ_FIELDS_KEY: symbol = Symbol('--READ-FIELDS-KEY--');
const WRITE_FIELDS_KEY: symbol = Symbol('--WRITE-FIELDS-KEY--');
const SNAPSHOT_KEY: symbol = Symbol('--SNAPSHOT_KEY--');
const TYPE_MAP_KEY: symbol = Symbol('--TYPE_MAP_KEY--');

export abstract class AbstractDto<T> {

    public readRawData(rawData: any): T {
        const self: any = this;

        if (rawData === null || rawData === undefined) {
            return <T> self;
        }

        const keys = getReadKeys(Object.getPrototypeOf(self));
        const typeMap = getTypeMap(Object.getPrototypeOf(self));

        for (const key of keys) {
            const type = typeMap.get(key);

            if (!(key in rawData)) {
                continue;
            }

            const rawValue = rawData[key];

            if (type && Array.isArray(rawValue)) {
                self[key] = rawValue.map(each => new type().readRawData(each));
            } else if (type) {
                self[key] = new type().readRawData(rawValue);
            } else {
                self[key] = rawValue;
            }
        }

        return <T> self;
    }

    takeSnapshot(): void {
        this[SNAPSHOT_KEY] = this.getState();
    }

    isChanged(): boolean {
        const lastState = this[SNAPSHOT_KEY];
        if (lastState === undefined) {
            throw Error('no last state');
        }

        return JSON.stringify(lastState) !== JSON.stringify(this.getState());
    }

    getState(): any {
        const keys = getWriteKeys(Object.getPrototypeOf(this));
        const typeMap = getTypeMap(Object.getPrototypeOf(this));

        const result = <any> {};
        for (const key of keys) {

            const type = typeMap.get(key);

            result[key] = type && this[key]
                ? (<any>this[key]).getState()
                : this[key];
        }

        return result;
    }

}

export function ReadField(target: any, propertyKey: string) {
    getReadKeys(target).push(propertyKey);
}

export function WriteField(target: any, propertyKey: string) {
    getWriteKeys(target).push(propertyKey);
}

export function ReadWriteField(target: any, propertyKey: string) {
    getReadKeys(target).push(propertyKey);
    getWriteKeys(target).push(propertyKey);
}

export function TypedReadField(type: any) {
    return (target: any, propertyKey: string | symbol) => {
        getReadKeys(target).push(propertyKey);
        getTypeMap(target).set(propertyKey, type);
    }
}

export function TypedReadWriteField(type: any) {
    return (target: any, propertyKey: string | symbol) => {
        getReadKeys(target).push(propertyKey);
        getWriteKeys(target).push(propertyKey);
        getTypeMap(target).set(propertyKey, type);
    }
}

function getTypeMap(target: any): Map<string | symbol, any> {
    return getOrCreate(target, TYPE_MAP_KEY,
        new Map<string | symbol, any>());
}

function getWriteKeys(target: any) : any {
    return getOrCreate(target, WRITE_FIELDS_KEY, []);
}

function getReadKeys(target: any) : any {
    return getOrCreate(target, READ_FIELDS_KEY, []);
}

function getOrCreate<T>(target: any, key: symbol, defaultValue: T): T  {
    if (!(key in target)) {
        target[key] = defaultValue;
    }

    return target[key];
}